export default "__VITE_ASSET__2ecb002b__"